import Tippy from "@tippyjs/react";
import React, { useEffect, useState } from "react";
import Icon1 from "../icons/Icon";

function TextField2T({
  label,
  value = "",
  mandatory = false,
  noborder = false,
  type = "text",
  mandatory_length = type === "phone" ? 14 : null,
  mandatory_characters = type === "email" ? ["@", "."] : [],
  useSuggestedValue = () => {},
  min = 0,
  max = null,
  onChange = () => {},
  className = "",
  autoComplete = "off",
  transparent = false,
  onEnter = () => {},
  onFocusLost = () => {},
  focusOnStart = false,
  disabled = false,
  items = [],
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onEnter();
    }
  };

  const [autoFilled, setAutoFilled] = useState(false);
  const [hovering, setHovering] = useState(false);
  const [displayValue, setDisplayValue] = useState("");
  const [focus, setFocus] = useState(false);
  const [localFocus, setLocalFocus] = useState(false); // For more direct control of focus state

  useEffect(() => {
    const input = document.getElementById(`input-${label}`);

    if (input) {
      setTimeout(() => {
        input.style.transition = "background-color 5000s ease-in-out 0s"; // Prevent instant reset
      }, 100);
    }

    // Initialize display value for euros type
    if (type === "euros" && value !== null && value !== undefined) {
      updateDisplayValue(value);
    }
  }, []);

  // Update display value when actual value changes
  useEffect(() => {
    if (type === "euros" && value !== null && value !== undefined) {
      updateDisplayValue(value);
    }
  }, [value, type]);

  // Format with nice Euro formatting or editing format depending on focus state
  const updateDisplayValue = (rawValue) => {
    if (type === "euros") {
      if (localFocus) {
        // When focused, show decimal with comma for editing
        setDisplayValue(String(rawValue).replace(".", ","));
      } else {
        // When not focused, show fully formatted currency
        setDisplayValue(formatEuroValue(rawValue));
      }
    }
  };

  const [suggestedValue, setSuggestedValue] = useState(null);

  const handleChange = (ee) => {
    let formatted;

    // Special handling for euros type
    if (type === "euros") {
      const inputValue = ee.target.value;

      // If it's a formatted value with currency symbol, we need to extract just the number
      if (inputValue.includes("€")) {
        // Don't process formatted values - this prevents issues when toggling focus
        return;
      }

      setDisplayValue(inputValue); // Update display value with what user types

      // Process for the actual value (convert comma to period for JS number handling)
      let processedValue = inputValue.replace(",", ".");

      // Only call onChange with the processed value (with period as decimal)
      const numericValue = Number(processedValue);
      if (
        !isNaN(numericValue) ||
        processedValue === "" ||
        processedValue === "-"
      ) {
        onChange({ target: { value: processedValue } });
      }

      return; // Exit early for euros type
    }

    // Original handling for other types
    formatted = forceformat(ee.target.value, type);
    let e = { ...ee, target: { ...ee.target, value: formatted } };
    onChange(e);

    const found = items.find((item) =>
      item.label.toLowerCase().includes(e.target.value.toLowerCase())
    );

    if (found && e.target.value?.length > 0) {
      setSuggestedValue(found);
    } else {
      setSuggestedValue(null);
    }
  };

  const handleFocus = () => {
    setFocus(true);
    setLocalFocus(true);

    // When focusing on euros type, switch to editable format
    if (
      type === "euros" &&
      value !== null &&
      value !== undefined &&
      value !== ""
    ) {
      setDisplayValue(String(value).replace(".", ","));
    }
  };

  const handleBlur = () => {
    setFocus(false);
    setLocalFocus(false);
    onFocusLost();

    // When leaving euros type, switch to formatted display
    if (type === "euros" && value !== null && value !== undefined) {
      setDisplayValue(formatEuroValue(value));
    }
  };

  let has_value = value !== null && value !== undefined && value !== "";
  let missing_mandatory_characters = has_value && mandatory_characters.some(
    (char) => !value.includes(char)
  );
  let mandatory_length_disrespect =
    mandatory_length && value?.length !== mandatory_length && has_value;
  let mandatory_disrespect =
    (mandatory && !value && !focus) ||
    missing_mandatory_characters ||
    mandatory_length_disrespect;
  let border_color = mandatory_disrespect
    ? "border-red-300"
    : focus || hovering
      ? "border-blue-300"
      : "border-gray-200";

  // Determine which value to display in the input
  const inputValue =
    type === "euros" ? displayValue : value === null ? "" : value;

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      className={`w-full min-h-11 h-11 relative flex flex-row select-none ${has_value ? "items-end" : "items-center py-1"} text-black ${className} 
      w-full
      px-2  
      
     
      rounded-xl
      ${noborder ? "" : focus ? "border-2 outline-1 outline-blue-100" : mandatory_disrespect ? "border-2 outline-1 outline-red-100" : "border    "}
      ${border_color}
      
      outline-none
      transition
      ease-in-out
      duration-150
      ${disabled ? "bg-neutral-100 cursor-not-allowed  text-shadow_50" : transparent ? "bg-transparent font-semibold" : "bg-white"}      
    `}
    >
      {has_value && (
        <div
          className={`
          
               ${focus || hovering ? "text-blue-400 font-medium" : "text-gray-300"}

          absolute top-1 text-h6 `}
        >
          {label}
        </div>
      )}
      {(mandatory_length_disrespect || missing_mandatory_characters) && (
        <div
          className={`absolute top-0 right-0 rounded-bl-lg px-1 pb-0.5 rounded-tr-lg bg-red-300 text-white  text-h6 `}
        >
          Champ invalide
        </div>
      )}
      {mandatory && !has_value && (
        <div
          className={`absolute top-0 right-0 rounded-bl-lg px-1 pb-0.5 rounded-tr-lg bg-red-300 text-white  text-h6 `}
        >
          Champ obligatoire
        </div>
      )}

      {!disabled && type !== "number" && type !== "euros" && (
        <div
          onClick={() => handleChange({ target: { value: "" } })}
          className={`absolute bg-neutral-100 rounded-full p-0.5 ${hovering && has_value ? "opacity-100" : "opacity-0"} cursor-pointer transition duration-300   ease-in-out top-1/3 right-3 text-gray-300 text-h6 `}
        >
          <Icon1
            icon_name="close"
            size={13}
            fill="grey"
            hover_color={"black"}
          />
        </div>
      )}

      {!disabled && type === "euros" && (
        <div
          onClick={() => {
            setDisplayValue("");
            onChange({ target: { value: "" } });
          }}
          className={`absolute bg-neutral-100 rounded-full p-0.5 ${hovering && has_value ? "opacity-100" : "opacity-0"} cursor-pointer transition duration-300   ease-in-out top-1/3 right-3 text-gray-300 text-h6 `}
        >
          <Icon1
            icon_name="close"
            size={13}
            fill="grey"
            hover_color={"black"}
          />
        </div>
      )}

      <input
        id={`input-${label}`}
        disabled={disabled}
        type={type === "euros" ? "text" : type} // Use text for euros to allow commas
        min={min}
        max={max}
        placeholder={label}
        value={inputValue}
        autoFocus={focusOnStart}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        autoComplete={autoComplete}
        className={`
          w-full
         
          rounded-xl
py-1       ${disabled ? "cursor-not-allowed " : " bg-transparent"}
          
          outline-none
          transition
          ease-in-out
          duration-150
          ${type === "euros" && !localFocus ? "text-right" : ""}
        `}
        style={{
          fontSize: "14px",
          backgroundColor: "transparent",
        }}
      />
      {suggestedValue && hovering && (
        <div
          onClick={() => useSuggestedValue(suggestedValue)}
          className="cursor-pointer absolute right-0  hover:text-blue-700 hover:bg-blue-100 flex max-w-c200 justify-center w-fit text-h4 text-blue-500 bg-blue-50 rounded-lg py-1 px-3 m-2"
        >
          Utiliser @{suggestedValue.label}
        </div>
      )}
    </div>
  );
}

export default TextField2T;

function forceformat(value, type) {
  if (type === "phone") {
    // Remove all non-numeric characters
    // Add a spaces after every 2 characters
    // Remove any spaces at the end
    // Limit to 14 characters
    return value
      .replace(/\D/g, "")
      .replace(/(\d{2})/g, "$1 ")
      .replace(/\s+$/, "")
      .slice(0, 14);
  }
  if (type === "siren") {
    // Remove all non-numeric characters
    // Add a spaces after every 3 characters
    // Remove any spaces at the end
    // Limit to 11 characters
    return value
      .replace(/\D/g, "")
      .replace(/(\d{3})/g, "$1 ")
      .replace(/\s+$/, "")
      .slice(0, 11);
  }
  if (type === "iban") {
    const cleaned = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    const countryCode = cleaned.slice(0, 2);
    const maxLength = countryCode === "FR" ? 27 : 34;

    return cleaned
      .slice(0, maxLength)
      .replace(/(.{4})(?=.)/g, "$1 ")
      .trim();
  }

  // No special formatting for other types
  return value;
}

// Helper function for formatting a currency value in European style
// This can be exported and used elsewhere if needed
export function formatEuroValue(value) {
  const numValue = Number(value);
  if (!isNaN(numValue)) {
    return new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      style: "currency",
      currency: "EUR",
    }).format(numValue);
  } else {
    return "0,00 €";
  }
}
